import LocalMallOutlined from '@mui/icons-material/LocalMallOutlined';
import EProduct from '../products';
import routes from '../routes';
import { IProductConfig } from './Products.types';

const supplyConfig: IProductConfig = {
  baseUrlProd: routes.ibProd,
  baseUrlSandbox: routes.ibSandbox,
  icon: <LocalMallOutlined />,
  modules: [
    {
      label: 'Purchase Orders',
      pageTitle: 'Purchase Orders',
      path: '/purchase-orders',
      roles: ['InboundAdmin', 'InboundTagger'],
    },
    {
      label: 'Suppliers',
      pageTitle: 'Suppliers',
      path: '/suppliers',
      roles: ['InboundAdmin'],
    },
  ],
  product: EProduct.inbound,
  title: 'Supply',
};

export default supplyConfig;
